var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 12,
    fill: "#D0FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2365 13.0026C30.6353 12.9557 33.0033 13.5491 35.0966 14.7214C37.1899 15.8938 38.933 17.6028 40.1465 19.6727C41.3597 21.7424 41.9996 24.0982 42 26.4975V35.4977C42 36.3927 41.6445 37.2513 41.0116 37.8842C40.3787 38.5172 39.5201 38.8727 38.625 38.8727H35.25V43.3727C35.25 43.9941 34.7463 44.4977 34.125 44.4977H22.875C22.2537 44.4977 21.75 43.9941 21.75 43.3727V38.1914C19.88 37.1118 18.2931 35.5973 17.1263 33.7724C15.8338 31.7511 15.1034 29.4218 15.0102 27.0243C14.917 24.6269 15.4644 22.2479 16.5961 20.1323C17.7278 18.0167 19.4028 16.241 21.4488 14.9878C23.4948 13.7347 25.8377 13.0494 28.2365 13.0026ZM20.759 29.2195C19.4084 25.4388 20.9064 21.1168 24.507 19.038C28.0617 16.9857 32.4853 17.8014 35.0982 20.7671C35.7601 21.5184 35.6062 22.6399 34.8633 23.311C32.0589 25.8441 27.4428 29.093 22.9091 30.294C22.013 30.5314 21.0708 30.0924 20.759 29.2195Z",
    fill: "#478F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/stroke.9ec1c6b232d505ffe66219d11d9004a0.svg";
export { ForwardRef as ReactComponent };